var map = {
	"./de.json": 720187,
	"./en.json": 409885,
	"./es.json": 221882,
	"./fr.json": 149519,
	"./it.json": 100022,
	"./ja.json": 557665,
	"./ko.json": 86876,
	"./pl.json": 948518,
	"./pt.json": 97226,
	"./ru.json": 721053,
	"./uk.json": 282413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486491;